import React, { useState } from 'react'
import styled from 'styled-components'
import { ThemeProvider, StylesProvider } from '@material-ui/styles'
import { createMuiTheme } from '@material-ui/core/styles'
import FormLayout from 'layouts/FormLayout'
import Preview from 'layouts/Preview';
import Dexie from 'dexie'
import Modal from 'components/Modal'
import DateFnsUtils from '@date-io/date-fns'
import plLocale from "date-fns/locale/pl";
import {
  MuiPickersUtilsProvider
} from '@material-ui/pickers'

// https://material-ui.com/guides/interoperability/#styled-components

// https://material-ui.com/customization/default-theme/
const theme = createMuiTheme({
  background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
})

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
`

const DesktopView = styled.div`
  display: none;
  flex: 1;
  @media screen and (min-width: 1280px) {
    display: block;
  }
`

const MobileView = styled.div`
  display: block;
  flex: 1;
  @media screen and (min-width: 1280px) {
    display: none;
  }
`

const defaultState = {
  preview: '',
  requestData: undefined,
  formValid: false,
  previewInModal: false
}

const App = () => {
  const [state, setSt] = useState(defaultState);

  const setState = (newState) => {
    setSt({
      ...state,
      ...newState
    })
  }

  const {
    preview,
    requestData,
    formValid,
    previewInModal
  } = state

  const openPreviewInModal = () => {
    setState({
      previewInModal: true
    })
  }

  const closePreviewInModal = () => {
    setState({
      previewInModal: false
    })
  }
  let db
  try {
    db = new Dexie('FormDatabase')
  } catch(err) {
    console.log(err)
  }
  console.log('preview', preview)

  return (
    <ThemeProvider theme={theme}>
      <StylesProvider injectFirst>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={plLocale}>
          <Container>
              <FormLayout
                db={new Dexie('FormDatabase')}
                onSave={(
                  preview,
                  values,
                  valid
                ) => {
                  setState({
                    requestData: values,
                    formValid: valid,
                    preview
                  })
                }}
                openModal={openPreviewInModal}
              />
              <DesktopView>
                <Preview
                  id='resume-preview'
                  preview={preview}
                  formValid={formValid}
                  requestData={requestData}
                />
              </DesktopView>
              <Modal onCloseClick={closePreviewInModal} show={previewInModal}>
                <Preview
                  id='resume-preview-2'
                  preview={preview}
                  formValid={formValid}
                  requestData={requestData}
                />
              </Modal>
          </Container>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
  )
}

export default App
